(function($){

	$(document).ready(function(){

		$(document).on('click','.faqs-accordion .question',function(e){
			$(this).parent().toggleClass('open');
			$(this).siblings('.answer').slideToggle();
		});

	});
	
})(jQuery);